import React from 'react';
import ExportButton from '../../../component/export-button/export-button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { renderCell } from '../../../component/data-table/operations/render-cell';
import { CelType } from '../../../component/data-table/data-table';

const studentsGradesData = [
  ['1', 'אלגברה לינארית', '1', '12/3/2024', 'ממתין לבדיקה'],
  ['2', 'אלגברה לינארית', '2', '12/3/2024', 'ממתין לבדיקה'],
  ['3', 'אלגברה לינארית', '2', '12/3/2024', 'ממתין לבדיקה'],
  ['4', 'אלגברה לינארית', '2', '12/3/2024', 'ממתין לבדיקה'],
];

const ExceptionExamHomePage = () => {
  return (
    <div
      style={{
        backgroundColor: '#ffffff',
        padding: '20px',
        height: '100%',
        borderRadius: '12px',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          marginBottom: '5px',
        }}
      >
        <div
          style={{ paddingBottom: '10px', color: '#185FD3', fontSize: '18px' }}
        >
          מבחנים בסטטוס חריג (4)
        </div>
        <ExportButton
          onClick={() => {
            // TODO
          }}
        />
      </div>
      <DataTable
        emptyMessage={<div style={{ textAlign: 'right' }}>לא נמצאו נתונים</div>}
        selectionMode={'multiple'}
        multiple={true}
        groupRowsBy="dsf"
        value={studentsGradesData}
        scrollHeight="200px"
        scrollable
        onSelectionChange={(e) => {
          //setSelectedUsers(e.value as UserSummaryType[]);
        }}
        dataKey="id"
        tableStyle={{
          direction: 'rtl',
          marginTop: '16px',
        }}
      >
        <Column
          style={{ textAlign: 'right', height: '40px' }}
          field="שלוחה"
          header="קורס"
          headerStyle={{
            height: '45px',
            maxHeight: '45px',
            padding: '0',
            paddingRight: '16.5px',
          }}
          body={(rowData) => <div>{rowData[1]}</div>}
        />
        <Column
          style={{ textAlign: 'right', height: '40px' }}
          field="שם"
          header="מועד"
          headerStyle={{
            height: '45px',
            maxHeight: '45px',
            padding: '0',
            paddingRight: '16.5px',
          }}
          body={(rowData) => <div>{rowData[2]}</div>}
        />

        <Column
          style={{ textAlign: 'right', height: '40px' }}
          header="תאריך"
          headerStyle={{
            height: '45px',
            maxHeight: '45px',
            padding: '0',
            paddingRight: '16.5px',
          }}
          body={(rowData, options) => (
            <div>
              {renderCell({
                type:
                  options.rowIndex / 2 === 0
                    ? CelType.RED_BG
                    : CelType.YELLOW_BG,
                content: rowData[3],
              })}
            </div>
          )}
        />

        <Column
          style={{ textAlign: 'right', height: '40px' }}
          field="סטטוס"
          header="סטטוס"
          headerStyle={{
            height: '45px',
            maxHeight: '45px',
            padding: '0',
            paddingRight: '16.5px',
          }}
          body={(rowData) => <div>{rowData[3]}</div>}
        />
      </DataTable>
    </div>
  );
};

export default ExceptionExamHomePage;
